import { createContext } from 'react';

import { State, ValidationStatusType } from './types';

export const INIT_STATE: State = {
  receiveReference: {
    errors: [],
    data: [],
    loading: false,
  },
  models: [],
  containers: {},
  serials: [],
  receiveReferenceList: [],
  serviceType: 'GRAPHQL',
  receiveReferences: [
    {
      receiveReference: {
        receiveReferenceId: 'no_reference',
        externalReferenceValue: '',
        expectedReceiveLocation: '',
        expectedDeliveryDateTime: '',
        supplier: '',
        trackingId: '',
        carrier: '',
        siteName: undefined,
        clusterName: undefined,
        referenceStatus: null,
        scannableId: '',
      },
      hasPermissionsToAccessIA: true,
      hasPermissionsToAccessReceive: true,
      scannableIdFoundAs: '',
      status: {
        validationStatusType: ValidationStatusType.OK,
        statusCode: undefined,
        statusMessage: undefined,
      },
    },
  ],
  activeReference: null,
  // initial shipment reference
  initialShipmentReferenceId: null,
  initialPackagingId: null,
  workRequestId: null,
  executions: [],
};

export const Context = createContext<State>(INIT_STATE);
